import Flickity from 'flickity';

const carousels = [];

export default function () {
  document.querySelectorAll('[data-press-tag-carousel]').forEach((el) => {
    if (
      el.getAttribute('initialized') === 'true' ||
      document.querySelectorAll('.PressTagCarousel--carousel .PressTagCarousel__tag').length <= 3
    ) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const carousel = new Flickity(el, {
      contain: true,
      groupCells: true,
      draggable: true,
    });

    carousels.push(carousel);
  });
}
